export default __webpack_public_path__ + "static/media/loyola3.167a9fbf.jpg";